import { render, staticRenderFns } from "./EliminarAsignacionEquipoSubsedeDialogComponent.vue?vue&type=template&id=1a82e313"
import script from "./EliminarAsignacionEquipoSubsedeDialogComponent.vue?vue&type=script&lang=js"
export * from "./EliminarAsignacionEquipoSubsedeDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports